import Vue from 'vue'
import VueRouter from 'vue-router'


//>>>> User

import Index from '../views/Index.vue'
import Success from '../views/Success.vue'
import Datatable from '../views/Datatable.vue'
import Form from '../views/Form.vue'
import Consults from '../views/Consults.vue'
import UserVerification from '../views/UserVerification.vue'
import RequestList from '../views/RequestList.vue'
import RequestDetail from '../views/RequestDetail.vue'
import DesignDataForm from '../views/DesignDataForm.vue'
import MonitoringActivity from '../views/MonitoringActivity.vue'
import PutInServiceActivity from '../views/PutInServiceActivity.vue'
import SupervisionRequest from '../views/SupervisionRequest.vue'
import LiquidationPayment from '../views/LiquidationPayment.vue'


//>>>> Admin
/*
import AdminLogin from '../views/AdminLogin.vue'
import AdminMonitoringActivity from '../views/AdminMonitoringActivity.vue'
import AdminUserList from '../views/AdminUserList.vue'
import CreateUser from '../views/CreateUser.vue'
import EditUser from '../views/EditUser.vue'
import AdminRequest from '../views/AdminRequest.vue'
import AdminRequestList from '../views/AdminRequestList.vue'
import AdminRequestDetail from '../views/AdminRequestDetail.vue'
import RefuseConnection from '../views/RefuseConnection.vue'
import RefuseDesigns from '../views/RefuseDesigns.vue'
import CancelConnection from '../views/CancelConnection.vue'
import EditarSolicitante from '../views/EditarSolicitante.vue'
import EditObservation from '../views/EditObservation.vue'
import LiquidationDesigns from '../views/LiquidationDesigns.vue'
*/

//Generales
import AssignSupervision from '../views/AssignSupervision.vue'
import ApprovedDesigns from '../views/ApprovedDesigns.vue'
import ApprovedConnection from '../views/ApprovedConnection.vue'
import MapRed from '../views/MapRed.vue'

Vue.use(VueRouter)

const routes = [
/** User */

  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/success',
    name: 'Success',
    component: Success
  },
  {
    path: '/form',
    name: 'Form',
    component: Form
  },
  {
    path: '/consults',
    name: 'Consults',
    component: Consults
  },
  {
    path: '/userVerification',
    name: 'UserVerification',
    component: UserVerification
  },
  {
    path: '/requestList',
    name: 'requestList',
    component: RequestList
  },
  {
    path: '/requestDetail',
    name: 'requestDetail',
    component: RequestDetail
  },
  {
    path: '/designDataForm',
    name: 'designDataForm',
    component: DesignDataForm
  },

  {
    path: '/monitoringActivity',
    name: 'MonitoringActivity',
    component: MonitoringActivity
  },
  {
    path: '/supervisionRequest',
    name: 'SupervisionRequest',
    component: SupervisionRequest
  },
  {
    path: '/putInServiceActivity',
    name: 'PutInServiceActivity',
    component: PutInServiceActivity
  },
  {
    path: '/datatable',
    name: 'Datatable',
    component: Datatable
  },
  {
    path: '/liquidationPayment',
    name: 'LiquidationPayment',
    component: LiquidationPayment
  },


  /** Admin */
/*
  {
    path: '/',
    name: 'adminRequestList',
    component: AdminRequestList
  },
  {
    path: '/adminUserList',
    name: 'AdminUserList',
    component: AdminUserList
  },
  {
    path: '/adminLogin',
    name: 'AdminLogin',
    component: AdminLogin
  },
  {
    path: '/createUser',
    name: 'CreateUser',
    component: CreateUser
  },
  {
    path: '/editUser',
    name: 'EditUser',
    component: EditUser
  },
  {
    path: '/cancelConnection',
    name: 'cancelConnection',
    component: CancelConnection
  },
  {
    path: '/editarSolicitante',
    name: 'editarSolicitante',
    component: EditarSolicitante
  },
  {
    path: '/editarObservation',
    name: 'editarObservation',
    component: EditObservation
  },
  {
    path: '/adminRequest',
    name: 'AdminRequest',
    component: AdminRequest
  },
  {
    path: '/adminRequestList',
    name: 'AdminRequestList',
    component: AdminRequestList
  },  
  {
    path: '/adminRequestDetail',
    name: 'AdminRequestDetail',
    component: AdminRequestDetail
  },
  {
    path: '/refuseConnection',
    name: 'RefuseConnection',
    component: RefuseConnection
  },
  {
    path: '/refuseDesigns',
    name: 'RefuseDesigns',
    component: RefuseDesigns
  },
  {
    path: '/adminMonitoringActivity',
    name: 'AdminMonitoringActivity',
    component: AdminMonitoringActivity
  },
  {
    path: '/liquidationDesigns',
    name: 'LiquidationDesigns',
    component: LiquidationDesigns
  },
*/

/** Generales */
  {
    path: '/approvedConnection',
    name: 'ApprovedConnection',
    component: ApprovedConnection
  },
  {
    path: '/approvedDesigns',
    name: 'Approved Designs',
    component: ApprovedDesigns
  },
  {
    path: '/assignSupervision',
    name: 'AssignSupervision',
    component: AssignSupervision
  },
  {
    path: '/mapared',
    name: 'MapRed',
    component: MapRed
  },
  
  
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
